import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../components/card/card";
import EmptyStateSection from "../../../components/emptyState/emptyStateSection";
import EvaluationCompetency from "./trainingReportTel2Component/evaluationCompetency";
import TrainingEvaluasiLvl2Toolbar from "./trainingReportTel2Component/toolbar";
import SpinnerSection from "../../../components/spinner/spinnerSecion";
import { useParams } from "react-router-dom";
import { detailTrainingTel2All } from "../../../config/apiSPA";

function TrainingReportTel2({ refresh = 1 }) {
  const { id } = useParams();

  const [evaluationData, setEvaluationData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isNotFound, setIsNotFound] = useState(false);
  const [openIndex, setOpenIndex] = useState(0);
  const handleCompetencyToggle = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const updateToolbar = (e) => {
    setEvaluationData(e);
    setIsNotFound(false);
  };

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      setIsNotFound(false);

      try {
        const res = await detailTrainingTel2All(id);

        setEvaluationData(res.data);
      } catch (error) {
        if (error.status === 404) {
          setIsNotFound(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [id, refresh]);

  return (
    <Card className="mb-4">
      <CardHeader className="d-flex align-items-center bg-inverse bg-opacity-10 fw-400">Training Evaluation Level 2 (Learning)</CardHeader>

      <CardBody>
        {isLoading ? (
          <SpinnerSection title="Loading....." />
        ) : isNotFound ? (
          <>
            <TrainingEvaluasiLvl2Toolbar onUpdate={updateToolbar} />
            <EmptyStateSection />
          </>
        ) : (
          <>
            <TrainingEvaluasiLvl2Toolbar onUpdate={(e) => setEvaluationData(e)} />
            {evaluationData.competencies.map((competency, index) => (
              <EvaluationCompetency key={index} isOpen={openIndex === index} onToggle={() => handleCompetencyToggle(index)} competency={competency} onUpdate={(e) => setEvaluationData(e)} />
            ))}
          </>
        )}
      </CardBody>
    </Card>
  );
}

export default TrainingReportTel2;
